import ConstructorIOClient from '@constructor-io/constructorio-client-javascript';
import { isCustomSection } from './typeGuards';
import version from './version';
export const getItemPosition = ({ item, items }) => {
    const index = items.findIndex((itemInFlatList) => itemInFlatList?.id === item?.id);
    const sectionId = items[index]?.section;
    return { sectionId, index };
};
export const camelToStartCase = (camelCaseString) => camelCaseString
    // insert a space before all caps
    .replace(/([A-Z])/g, ' $1')
    // uppercase the first character
    .replace(/^./, (str) => str.toUpperCase());
export function isTrackingRequestSent(trackingRequestUrl) {
    // eslint-disable-next-line
    const trackingRequestsQueue = window.localStorage?._constructorio_requests;
    return (trackingRequestsQueue &&
        JSON.parse(trackingRequestsQueue)?.some((request) => request?.url?.includes(trackingRequestUrl)));
}
export function clearConstructorRequests() {
    // eslint-disable-next-line
    if (window.localStorage?._constructorio_requests) {
        window.localStorage.removeItem('_constructorio_requests');
    }
}
// Function to emulate pausing between interactions
export function sleep(ms) {
    // eslint-disable-next-line
    return new Promise((resolve) => setTimeout(resolve, ms));
}
// More on Story layout: https://storybook.js.org/docs/react/configure/story-layout
export const getStoryParams = (storyCode, templateCode, importCode) => {
    const code = `
${importCode}
${storyCode}
${templateCode}
`;
    return {
        docs: {
            source: {
                code,
                language: 'jsx',
                format: true,
                type: 'code',
            },
        },
    };
};
export const functionStrings = {
    onSubmit: `(submitEvent) => console.dir(submitEvent)`,
};
export const stringifyWithDefaults = (obj) => {
    // Stringify non-function values normally. Add a template block for functions to be replaced later
    let res = JSON.stringify(obj, (key, value) => (value instanceof Function ? `${key}_CODE` : value), '  ');
    // Replace template blocks with function strings
    Array.from(res.matchAll(/"(\w*)_CODE"/g)).forEach((match) => {
        const [codePlaceholder, key] = match;
        const functionString = functionStrings[key];
        if (functionString) {
            res = res.replaceAll(codePlaceholder, functionString);
        }
        else {
            console.error(`Function string for ${key} not found.`); // eslint-disable-line
        }
    });
    return res;
};
export const disableStoryActions = (story) => {
    // eslint-disable-next-line
    story.parameters.actions = { argTypesRegex: null };
};
export const getCioClient = (apiKey) => {
    if (apiKey) {
        return new ConstructorIOClient({
            apiKey,
            sendTrackingEvents: true,
            version: `cio-ui-autocomplete-${version}`,
        });
    }
    return null;
};
export const getActiveSectionsWithData = (activeSections, sectionResults) => {
    const activeSectionsWithData = [];
    activeSections?.forEach((config) => {
        const { identifier } = config;
        let data;
        if (isCustomSection(config)) {
            // Copy id from data to the top level
            data = config.data.map((item) => ({
                ...item,
                id: item?.id || item?.data?.id,
            }));
        }
        else {
            data = sectionResults[identifier];
        }
        if (Array.isArray(data)) {
            activeSectionsWithData.push({ ...config, data });
        }
    });
    return activeSectionsWithData;
};
export const escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
